/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrossOff = createReactComponent("outline", "cross-off", "IconCrossOff", [["path", { "d": "M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

export { IconCrossOff as default };
//# sourceMappingURL=IconCrossOff.mjs.map
